import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "preview", "zone", "previewWrap", "empty", "filename"];
  static values = { currentUrl: String };

  connect() {
    // Preview wiring handled by server-rendered image_tag when editing existing files.
  }

  browse(event) {
    event?.preventDefault();
    event?.stopPropagation();
    this.inputTarget.click();
  }

  preview() {
    const file = this.inputTarget.files?.[0];
    if (!file) return;

    this.showFilename(file.name);

    if (!this.hasPreviewTarget || !file.type.startsWith("image/")) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      this.previewTarget.src = e.target.result;
      this.previewTarget.classList.remove("hidden");
      this.hideEmpty();
      this.zoneTarget?.classList.add("image-upload-zone--has-image");
    };
    reader.readAsDataURL(file);
  }

  filename() {
    const file = this.inputTarget.files?.[0];
    if (!file) return;

    this.showFilename(file.name);
    this.hideEmpty();
    this.zoneTarget?.classList.add("image-upload-zone--has-image");
  }

  dragover(event) {
    event.preventDefault();
    this.zoneTarget?.classList.add("image-upload-zone--drag");
  }

  dragleave() {
    this.zoneTarget?.classList.remove("image-upload-zone--drag");
  }

  drop(event) {
    event.preventDefault();
    this.dragleave();
    const file = event.dataTransfer.files?.[0];
    if (!file) return;
    const dt = new DataTransfer();
    dt.items.add(file);
    this.inputTarget.files = dt.files;
    if (file.type.startsWith("image/")) {
      this.preview();
    } else {
      this.filename();
    }
  }

  showFilename(name) {
    if (!this.hasFilenameTarget) return;
    this.filenameTarget.textContent = name;
    this.filenameTarget.classList.remove("hidden");
  }

  hideEmpty() {
    if (this.hasEmptyTarget) this.emptyTarget.classList.add("hidden");
    if (this.hasPreviewWrapTarget) this.previewWrapTarget.classList.remove("hidden");
  }
}
